// extracted by mini-css-extract-plugin
export var container = "gx_f";
export var countryCurrencyContainer = "gx_nN";
export var imageContainer = "gx_c5";
export var name = "gx_lN";
export var skeleton = "gx_nP";